import { IWPImage, IWPLink } from "@/src/types";
import React from "react";

import S from "./TextImage.styled";
import { getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

export interface Props {
  title: string;
  subTitle: string;
  text: string;
  link: IWPLink;
  image: IWPImage;
}

const TextImage: React.FC<Props> = ({ title, subTitle, text, link, image }) => {
  const imageData = image?.localFile?.childImageSharp?.gatsbyImageData
    ? getImage(image.localFile.childImageSharp.gatsbyImageData)
    : null;

  return (
    <section
      className={
        "relative block text-center items-start grid-cols-2 grid-flow-col gap-4 py-20 md:mx-auto md:max-w-7xl md:py-28 md:grid md:text-left"
      }
    >
      <div className="flex-1 flex flex-col items-baseline px-12 md:pb-0 pb-6">
        <h3 className="w-full text-4xl text-center mt-0 mb-0 md:text-left">
          {title}
        </h3>
        <h4 className="w-full text-center mt-2 mb-2.5 md:mt-6 md:text-left">
          {subTitle && subTitle}
        </h4>
        <div dangerouslySetInnerHTML={{ __html: text }} />
        {link && link.url && (
          <Link to={link.url}>
            <div className="mt-6 text-base font-medium md:mx-0 mx-auto rounded-full text-white bg-metlab-500 transition duration-200 ease-in-out hover:bg-green-600 py-4 px-10">
              {link.title}
            </div>
          </Link>
        )}
      </div>
      <div className="flex-1 rounded-md mx-6 h-full w-full relative">
        {imageData && (
          <S.Image
            image={imageData}
            alt={"Bild på jobb"}
            objectFit={"cover"}
            className={"rounded-lg h-full"}
          />
        )}
      </div>
    </section>
  );
};

export default TextImage;
